import React, { useMemo, useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import StoreList from './StoreList';
import StoreListStyle from '../../../assets/stylesheets/store/StoreList.module.css';
import StoreStyle from '../../../assets/stylesheets/store/StorePage.module.css';

// Images reused from existing categories/components

// Farm
import White from '../../../assets/img/sample/White.jpg';
import Red from '../../../assets/img/sample/Red.jpg';
import Rose from '../../../assets/img/sample/Rose.jpg';
import Sparkling from '../../../assets/img/sample/Sparkling.jpg';
import Cider from '../../../assets/img/sample/Cider.jpg';
import Glass from '../../../assets/img/sample/glass.jpg';

// Deal of week
import Apple from '../../../assets/img/sample/Apple.jpg';
import Tomato from '../../../assets/img/sample/Tomato.jpg';
import Bread from '../../../assets/img/sample/Bread.jpg';
import Egg from '../../../assets/img/sample/Egg.jpg';
import Steak from '../../../assets/img/sample/Steak.jpg';
import Croissants from '../../../assets/img/sample/Croissants.jpg';

// New this week
import Brioche from '../../../assets/img/sample/Pumpkin-Brioche.jpg';
import Chard from '../../../assets/img/sample/Chard.jpg';
import DelicataSquash from '../../../assets/img/sample/Delicata Squash.jpg';
import Kielbasa from '../../../assets/img/sample/Smoked Kielbasa.jpg';
import Cranberry from '../../../assets/img/sample/Cranberry.jpg';
import SyrupsHoney from '../../../assets/img/sample/Syrups-Honey.jpg';

// Popular items
import Strawberry from '../../../assets/img/sample/Strawberry Preserves.jpg';
import Mozzarella from '../../../assets/img/sample/Fresh Mozzarella.jpg';
import Broccoli from '../../../assets/img/sample/Broccoli Crowns.jpg';
import Mushrooms from '../../../assets/img/sample/Cremini Mushrooms.jpg';
import Onion from '../../../assets/img/sample/Onion.jpg';
import Potatoes from '../../../assets/img/sample/Potatoes.jpg';

// Seasonal picks
import ButternutSquash from '../../../assets/img/sample/Butternut Squash.jpg';
import AcornSquash from '../../../assets/img/sample/Acorn Squash.jpg';
import Pumpkin from '../../../assets/img/sample/Sugar Pie Pumpkin.jpg';
import Leeks from '../../../assets/img/sample/Leeks.jpg';
import Grapes from '../../../assets/img/sample/Concord Grapes.jpg';
import Beets from '../../../assets/img/sample/Chioggia Beets.jpg';

import FlowersImg from '../../../assets/img/sample/Flowers.jpg';
import FrozenImg from '../../../assets/img/sample/Frozen.jpg';
import WineImg from '../../../assets/img/sample/Wine.jpg';
import PantryImg from '../../../assets/img/sample/Pantry.jpg';
import ProduceBoxesImg from '../../../assets/img/sample/Produce-Boxes.jpg';

//Fruits
import Strawberries from '../../../assets/img/sample/Strawberries.jpg';
import Raspberries from '../../../assets/img/sample/Raspberries.jpg';
import Blueberries from '../../../assets/img/sample/Blueberries.jpg';
import Cherries from '../../../assets/img/sample/Cherries.jpg';
import Pears from '../../../assets/img/sample/Pears.jpg';
import Plums from '../../../assets/img/sample/Plums.jpg';
import Peaches from '../../../assets/img/sample/Peaches.jpg';
import AmbrosiaApple from '../../../assets/img/sample/AmbrosiaApple.jpg';
import McIntoshApple from '../../../assets/img/sample/McIntoshApple.jpg';
import GalaApple from '../../../assets/img/sample/GalaApple.jpg';

// Vegetables
import Garlic from '../../../assets/img/sample/Garlic.jpg';
import Cauliflower from '../../../assets/img/sample/Cauliflower.jpg';
import SweetCorn from '../../../assets/img/sample/Sweet corn.jpg';
import Carrots from '../../../assets/img/sample/Carrots.jpg';
import Cabbage from '../../../assets/img/sample/Cabbage.jpg';
import Cucumbers from '../../../assets/img/sample/Cucumbers.jpg';
import Peppers from '../../../assets/img/sample/Peppers.jpg';
//tomato + broccoli + onion

// Dairy & Eggs
import BlueCheese from '../../../assets/img/sample/Blue cheese.jpg';
import GoatCheese from '../../../assets/img/sample/goat cheese.jpg';
import Cheddar from '../../../assets/img/sample/Cheddar.jpg';
import Butter from '../../../assets/img/sample/Butter.jpg';
import Yogurt from '../../../assets/img/sample/Yogurt.jpg';
import Milk from '../../../assets/img/sample/Milk.jpg';

// Meat & Seafood
import Duck from '../../../assets/img/sample/Duck breast.jpg';
import Trout from '../../../assets/img/sample/Rainbow Trout.jpg';
import Lamb from '../../../assets/img/sample/Lamb chops.jpg';
import Turkey from '../../../assets/img/sample/Turkey.jpg';
import PorkRibs from '../../../assets/img/sample/Pork Ribs.jpg';
import PorkChops from '../../../assets/img/sample/Pork Chops.jpg';
import BeefBrisket from '../../../assets/img/sample/Beef Brisket.jpg';
import Tenderloin from '../../../assets/img/sample/beef tenderloin.jpg';
import GroundBeef from '../../../assets/img/sample/Ground Beef.jpg';
import ChickenBreast from '../../../assets/img/sample/chicken breast.jpg';
import PorkBelly from '../../../assets/img/sample/PorkBelly.jpg';

// Flowers
import Echinacea from '../../../assets/img/sample/Echinacea.jpg';
import Geraniums from '../../../assets/img/sample/Geraniums.jpg';
import Hydrangeas from '../../../assets/img/sample/Hydrangeas.jpg';
import Poinsettias from '../../../assets/img/sample/Poinsettias.jpg';
import Roses from '../../../assets/img/sample/Roses.jpg';
import Tulips from '../../../assets/img/sample/Tulips.jpg';
import Lavender from '../../../assets/img/sample/Lavender.jpg';
import Sunflowers from '../../../assets/img/sample/Sunflowers.jpg';

// Left sidebar categories
const CATEGORIES = [
  { title: 'New & Season', slug: 'new-peak-season' },
  { title: 'Fruits', slug: 'fruits' },
  { title: 'Vegetables', slug: 'vegetables' },
  { title: 'Flowers', slug: 'flowers' },
  { title: 'Meat & Seafood', slug: 'meat-seafood' },
  { title: 'Dairy & Eggs', slug: 'dairy-eggs' },
  { title: 'Bakery', slug: 'bakery' },
  { title: 'Frozen', slug: 'frozen' },
  { title: 'Syrups & Honey', slug: 'syrups-honey' },
  { title: 'Wine & Cider', slug: 'wine-cider' },
  { title: 'Pantry', slug: 'pantry' },
  { title: 'Produce Boxes', slug: 'produce-boxes' }
];

// Sidebar topic shortcuts
const TOPIC_LINKS = [
  { title: 'Deals of Week', slug: 'deals' },
  { title: 'New This Week', slug: 'new' },
  { title: 'Mockridge Farm', slug: 'spotlight' },
  { title: 'Popular Items', slug: 'popular' },
  { title: 'Seasonal Picks', slug: 'seasonal' },
];

// Datasets (copied from existing components for consistency)
const POPULAR_ITEMS = [
  { id: 'pop-1', name: 'Strawberry Preserves', price: '$5.99/12oz', info: 'Small-batch • Classic spread', img: Strawberry },
  { id: 'pop-2', name: 'Fresh Mozzarella', price: '$6.99/8oz', info: 'Creamy • Hand-packed', img: Mozzarella },
  { id: 'pop-3', name: 'Broccoli Crowns', price: '$2.49/lb', info: 'Tender florets • Fresh cut', img: Broccoli },
  { id: 'pop-4', name: 'Cremini Mushrooms', price: '$3.79/lb', info: 'Firm texture • Earthy flavor', img: Mushrooms },
  { id: 'pop-5', name: 'Sweet Onions', price: '$1.29/lb', info: 'Mild & sweet • Great for roasting', img: Onion },
  { id: 'pop-6', name: 'Yukon Gold Potatoes', price: '$1.49/lb', info: 'Buttery • Creamy texture', img: Potatoes },
];

const SEASONAL_ITEMS = [
  { id: 'sea-1', name: 'Butternut Squash', price: '$1.49/lb', info: 'Sweet & nutty • Roasts beautifully', img: ButternutSquash },
  { id: 'sea-2', name: 'Acorn Squash', price: '$1.29/lb', info: 'Tender flesh • Great for stuffing', img: AcornSquash },
  { id: 'sea-3', name: 'Sugar Pie Pumpkin', price: '$3.99/ea', info: 'Perfect for pies • Small & sweet', img: Pumpkin },
  { id: 'sea-4', name: 'Leeks', price: '$2.49/bunch', info: 'Mild & aromatic • Ideal for soups', img: Leeks },
  { id: 'sea-5', name: 'Concord Grapes', price: '$3.49/lb', info: 'Richly aromatic • Jelly favorite', img: Grapes },
  { id: 'sea-6', name: 'Chioggia Beets', price: '$2.49/bunch', info: 'Candy-striped • Sweet & crisp', img: Beets },
];

const NEW_ITEMS = [
  { id: 'new-1', name: 'Pumpkin Brioche', price: '$6.95', info: 'Freshly baked • Seasonal', img: Brioche },
  { id: 'new-2', name: 'Rainbow Swiss Chard', price: '$2.99/bunch', info: 'New harvest • Color mix', img: Chard },
  { id: 'new-3', name: 'Delicata Squash', price: '$1.99/lb', info: 'First harvest • Tender & sweet', img: DelicataSquash },
  { id: 'new-4', name: 'Smoked Kielbasa', price: '$9.99', info: 'Small-batch • Hardwood smoked', img: Kielbasa },
  { id: 'new-5', name: 'Fresh Cranberries (Local)', price: '$3.99/12oz', info: 'New arrival • Tart & vibrant', img: Cranberry },
  { id: 'new-6', name: 'Raw Wildflower Honey', price: '$8.99', info: 'Fall harvest • Unfiltered', img: SyrupsHoney },
];

const DEALS_ITEMS = [
  { id: 'deal-1', name: 'Honeycrisp Apples', price: '$3.99/lb', info: 'Save 20% • Peak season', discount: 20, img: Apple },
  { id: 'deal-2', name: 'Heirloom Tomatoes', price: '$2.79/lb', info: 'Save 20% • Vine-ripened', discount: 20, img: Tomato },
  { id: 'deal-3', name: 'Sourdough Bread', price: '$5.20', info: 'Bundle: 2 for $9.99', discount: 15, img: Bread },
  { id: 'deal-4', name: 'Free-range Eggs', price: '$4.79/dozen', info: 'Save $1.20 • Local farm', discount: 20, img: Egg },
  { id: 'deal-5', name: 'Grass-fed Steak', price: '$15.99/lb', info: 'Weekly special', discount: 10, img: Steak },
  { id: 'deal-6', name: 'Butter Croissants', price: '$3.99', info: 'Buy 3 get 1 free', discount: 25, img: Croissants },
];

// Spotlight dataset
const SPOTLIGHT_ITEMS = [
  { id: 'spot-1', name: 'Farmhouse White (750ml)',  price: '$14.99', info: 'Crisp • Notes of citrus',             img: White },
  { id: 'spot-2', name: 'Heritage Red (750ml)',     price: '$16.99', info: 'Bold • Dark berry & spice',           img: Red },
  { id: 'spot-3', name: 'Dry Rosé (750ml)',         price: '$13.99', info: 'Refreshing • Summer fruit',           img: Rose },
  { id: 'spot-4', name: 'Sparkling Brut (750ml)',   price: '$18.99', info: 'Small-batch • Traditional method',    img: Sparkling },
  { id: 'spot-5', name: 'Farm Apple Cider (1L)',    price: '$6.99',  info: 'Cold-pressed • Unfiltered',          img: Cider },
  { id: 'spot-6', name: 'Tasting Glass Set (2pc)',  price: '$9.99',  info: 'Etched logo • Gift-ready',           img: Glass },
];

// Simple sample datasets per category slug
const CATEGORY_ITEMS = {
  'fruits': [
    { id: 'fr-1', name: 'Honeycrisp Apples', price: '$3.99/lb', info: 'Crisp & juicy', img: Apple },
    { id: 'fr-2', name: 'Gala Apples', price: '$2.49/lb', info: 'Sweet & mild • Great for snacks', img: GalaApple },
    { id: 'fr-3', name: 'McIntosh Apples', price: '$2.29/lb', info: 'Tart-sweet • Ideal for sauce', img: McIntoshApple },
    { id: 'fr-4', name: 'Ambrosia Apples', price: '$2.99/lb', info: 'Honey-sweet • Low acidity', img: AmbrosiaApple },
    { id: 'fr-5', name: 'Peaches', price: '$2.99/lb', info: 'Juicy & fragrant • Tree-ripened', img: Peaches },
    { id: 'fr-6', name: 'Plums', price: '$2.79/lb', info: 'Sweet–tart • Firm flesh', img: Plums },
    { id: 'fr-7', name: 'Pears', price: '$2.49/lb', info: 'Buttery texture • Bartlett/Anjou', img: Pears },
    { id: 'fr-8', name: 'Cherries', price: '$4.99/lb', info: 'Crisp & sweet • Stem-on', img: Cherries },
    { id: 'fr-9', name: 'Blueberries', price: '$3.49/6oz', info: 'Bursting flavor • Antioxidant-rich', img: Blueberries },
    { id: 'fr-10', name: 'Raspberries', price: '$3.99/6oz', info: 'Delicate & tangy • Hand-picked', img: Raspberries },
    { id: 'fr-11', name: 'Strawberries', price: '$3.99/1lb', info: 'Sweet & fragrant • Field-fresh', img: Strawberries },

  ],
  'vegetables': [
    { id: 've-1', name: 'Garlic Bulbs', price: '$1.99/head', info: 'Pungent • Fresh bulbs', img: Garlic },
    { id: 've-2', name: 'Cauliflower', price: '$2.99/ea', info: 'Snow-white • Tender florets', img: Cauliflower },
    { id: 've-3', name: 'Sweet Corn', price: '$0.79/ear', info: 'Fresh-picked • Super sweet', img: SweetCorn },
    { id: 've-4', name: 'Carrots', price: '$1.49/lb', info: 'Crunchy & sweet • Washed', img: Carrots },
    { id: 've-5', name: 'Heirloom Tomatoes', price: '$2.79/lb', info: 'Vine-ripened • Rich flavor', img: Tomato },
    { id: 've-6', name: 'Green Cabbage', price: '$0.99/lb', info: 'Crisp leaves • Great for slaw', img: Cabbage },
    { id: 've-7', name: 'Cucumbers', price: '$1.29/ea', info: 'Cool & crisp • Salad-ready', img: Cucumbers },
    { id: 've-8', name: 'Bell Peppers', price: '$1.49/ea', info: 'Assorted colors • Sweet & crunchy', img: Peppers },
  ],
  'flowers': [
    { id: 'fl-1', name: 'Seasonal Bouquet', price: '$14.99', info: 'Mixed seasonal blooms', img: FlowersImg },
    { id: 'fl-2', name: 'Echinacea Bunch', price: '$7.99/bunch', info: 'Coneflower • Pollinator-friendly', img: Echinacea },
    { id: 'fl-3', name: 'Geraniums (Pot)', price: '$5.99/ea', info: 'Bright blooms • Patio-ready', img: Geraniums },
    { id: 'fl-4', name: 'Hydrangea Stems', price: '$12.99/bunch', info: 'Large heads • Fresh cut', img: Hydrangeas },
    { id: 'fl-5', name: 'Poinsettia (Holiday Pot)', price: '$8.99/ea', info: 'Festive red • Long-lasting', img: Poinsettias },
    { id: 'fl-6', name: 'Garden Roses (Dozen)', price: '$16.99/dozen', info: 'Fragrant • Mixed colors', img: Roses },
    { id: 'fl-7', name: 'Tulip Bunch', price: '$7.49/bunch', info: 'Spring favorite • Assorted colors', img: Tulips },
    { id: 'fl-8', name: 'Fresh Lavender', price: '$6.99/bunch', info: 'Aromatic • Culinary or craft use', img: Lavender },
    { id: 'fl-9', name: 'Sunflower Bunch', price: '$6.99/bunch', info: 'Bold & cheerful • Farm-grown', img: Sunflowers },
  ],
  'meat-seafood': [
    { id: 'ms-1', name: 'Grass-fed Steak', price: '$15.99/lb', info: 'Local, dry-aged', img: Steak },
    { id: 'ms-2', name: 'Smoked Kielbasa', price: '$9.99', info: 'Hardwood smoked', img: Kielbasa },
    { id: 'ms-3', name: 'Duck Breast', price: '$12.99/lb', info: 'Boneless • Rich flavor', img: Duck },
    { id: 'ms-4', name: 'Rainbow Trout Fillet', price: '$11.99/lb', info: 'Fresh • Mild taste', img: Trout },
    { id: 'ms-5', name: 'Lamb Chops', price: '$18.99/lb', info: 'Tender • Pasture-raised', img: Lamb },
    { id: 'ms-6', name: 'Turkey Breast', price: '$6.99/lb', info: 'Lean & versatile', img: Turkey },
    { id: 'ms-7', name: 'Pork Ribs', price: '$5.49/lb', info: 'Meaty • BBQ favorite', img: PorkRibs },
    { id: 'ms-8', name: 'Pork Chops', price: '$5.99/lb', info: 'Center-cut • Juicy & tender', img: PorkChops },
    { id: 'ms-9', name: 'Beef Brisket', price: '$7.99/lb', info: 'Perfect for slow-cooking', img: BeefBrisket },
    { id: 'ms-10', name: 'Beef Tenderloin', price: '$19.99/lb', info: 'Center-cut • Extra tender', img: Tenderloin },
    { id: 'ms-11', name: 'Ground Beef', price: '$5.49/lb', info: 'Lean • Daily ground', img: GroundBeef },
    { id: 'ms-12', name: 'Chicken Breast', price: '$4.49/lb', info: 'Boneless • Skinless', img: ChickenBreast },
    { id: 'ms-13', name: 'Pork Belly', price: '$6.49/lb', info: 'Rich • Ideal for roasting', img: PorkBelly },
  ],
  'dairy-eggs': [
    { id: 'de-1', name: 'Fresh Mozzarella', price: '$6.99/8oz', info: 'Creamy • Hand-packed', img: Mozzarella },
    { id: 'de-2', name: 'Free-range Eggs', price: '$4.79/dozen', info: 'Pasture-raised • Local farm', img: Egg },
    { id: 'de-3', name: 'Blue Cheese', price: '$7.99/8oz', info: 'Tangy & crumbly • Cave-aged', img: BlueCheese },
    { id: 'de-4', name: 'Goat Cheese', price: '$6.49/8oz', info: 'Creamy & tangy • Farmstead', img: GoatCheese },
    { id: 'de-5', name: 'Sharp Cheddar', price: '$5.99/8oz', info: 'Aged • Bold flavor', img: Cheddar },
    { id: 'de-6', name: 'Creamery Butter', price: '$3.99/8oz', info: 'Rich & creamy • 82% butterfat', img: Butter },
    { id: 'de-7', name: 'Plain Yogurt', price: '$4.29/16oz', info: 'Live cultures • Whole milk', img: Yogurt },
    { id: 'de-8', name: 'Whole Milk', price: '$3.49/half-gal', info: 'Non-homogenized • Local dairy', img: Milk },
  ],
  'bakery': [
    { id: 'ba-1', name: 'Sourdough Bread', price: '$5.20', info: 'Naturally leavened', img: Bread },
    { id: 'ba-2', name: 'Butter Croissants', price: '$3.99', info: 'Flaky & buttery', img: Croissants },
    { id: 'ba-3', name: 'Pumpkin Brioche', price: '$6.95', info: 'Seasonal special', img: Brioche },
  ],
  'frozen': [
    { id: 'frz-1', name: 'Mixed Berries (Frozen)', price: '$4.99', info: 'Great for smoothies', img: FrozenImg },
    { id: 'frz-2', name: 'Garden Peas (Frozen)', price: '$2.99', info: 'Quick & easy', img: FrozenImg },
  ],
  'syrups-honey': [
    { id: 'sh-1', name: 'Raw Wildflower Honey', price: '$8.99', info: 'Unfiltered', img: SyrupsHoney },
    { id: 'sh-2', name: 'Strawberry Preserves', price: '$5.99/12oz', info: 'Classic spread', img: Strawberry },
  ],
  'wine-cider': [
    { id: 'wc-1', name: 'Apple Cider', price: '$6.99/half-gal', info: 'Pressed locally', img: WineImg },
    { id: 'wc-2', name: 'Farmhouse Wine', price: '$12.99', info: 'Small-batch', img: WineImg },
  ],
  'pantry': [
    { id: 'pa-1', name: 'Local Preserves', price: '$5.99', info: 'Assorted flavors', img: Strawberry },
    { id: 'pa-2', name: 'Kitchen Staples', price: '$—', info: 'Essentials for home cooking', img: PantryImg },
  ],
  'produce-boxes': [
    { id: 'pb-1', name: 'Vegetable Box (Small)', price: '$19.99', info: 'Weekly assortment', img: ProduceBoxesImg },
    { id: 'pb-2', name: 'Vegetable Box (Large)', price: '$34.99', info: 'Feeds 3–4', img: ProduceBoxesImg },
  ],
  'new-peak-season': SEASONAL_ITEMS,
};

const TOPICS = {
  popular: { title: 'Popular items', items: POPULAR_ITEMS },
  seasonal: { title: 'Seasonal picks', items: SEASONAL_ITEMS },
  new: { title: 'New This Week', items: NEW_ITEMS },
  deals: { title: 'This Week’s Deals', items: DEALS_ITEMS, showDiscountBadge: true },
  spotlight: { title: 'Farm Spotlight', items: SPOTLIGHT_ITEMS },
};

export default function StoreListPage() {
  const { mode, slug } = useParams(); // mode: 'topic' | 'category', slug: string
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 300);
    return () => clearTimeout(t);
  }, [mode, slug]);

  const { title, items, showDiscountBadge } = useMemo(() => {
    if (mode === 'topic') {
      return TOPICS[slug] || { title: 'Not found', items: [] };
    }
    if (mode === 'category') {
      const cat = CATEGORIES.find(c => c.slug === slug);
      return { title: cat ? cat.title : 'Not found', items: CATEGORY_ITEMS[slug] || [] };
    }
    return { title: 'Browse', items: [] };
  }, [mode, slug]);

  const activeCategory = mode === 'category' ? slug : null;
  const activeTopic = mode === 'topic' ? slug : null;

  return (
    <div className={StoreListStyle['store-list-page']}>
      <div className={StoreListStyle['store-list-back-row']}>
        <Link to="/store" className={StoreListStyle['store-list-back-link']}>← Back to Store</Link>
      </div>

      <div className={StoreListStyle['store-list-grid']}>
        <aside className={StoreListStyle['store-list-sidebar']}>
          <div className={StoreListStyle['store-list-section-title-sm']}>Topics</div>
          <nav className={`${StoreListStyle['store-list-nav-list']} ${StoreListStyle['store-list-topics']}`}>
            {TOPIC_LINKS.map((t) => {
              const isActive = activeTopic === t.slug;
              const isSpotlight = t.slug === 'spotlight';
              const cls = [StoreListStyle['store-list-nav-link']];
              if (isSpotlight) cls.push(StoreListStyle['store-list-spotlight-accent']);
              if (isActive) cls.push(StoreListStyle['store-list-active']);
              if (isActive && isSpotlight) cls.push(StoreListStyle['store-list-spotlight-active']);
              return (
                <Link
                  key={t.slug}
                  to={`/store/list/topic/${t.slug}`}
                  className={cls.join(' ')}
                  aria-label={isSpotlight ? `${t.title} (Spotlight)` : t.title}
                >
                  <span>{t.title}</span>
                  {isSpotlight ? <span aria-hidden="true">🌾</span> : null}
                </Link>
              );
            })}
          </nav>

          <div className={StoreListStyle['store-list-divider']} />

          <div className={StoreListStyle['store-list-section-title']}>Categories</div>
          <nav className={StoreListStyle['store-list-nav-list']}>
            {CATEGORIES.map((c) => {
              const cls = [StoreListStyle['store-list-nav-link']];
              if (activeCategory === c.slug) cls.push(StoreListStyle['store-list-active']);
              return (
                <Link
                  key={c.slug}
                  to={`/store/list/category/${c.slug}`}
                  className={cls.join(' ')}
                >
                  {c.title}
                </Link>
              );
            })}
          </nav>


        </aside>

        <main>
            {/* Farm Store is under active development. We’re building something exciting. Stay tuned! */}
            <div className={`${StoreStyle.notice} ${StoreStyle['notice--blue']}`} role="note">
                <span aria-hidden="true" className={StoreStyle['notice-emoji']}>ℹ️</span>
                <p className={StoreStyle['notice-text']}>
                Farm Store is under active development. We’re building something exciting. The page you’re viewing is a mockup and is not yet functional.
                </p>
            </div>
            

          <StoreList title={title} items={items} loading={loading} showDiscountBadge={!!showDiscountBadge} />
        </main>
      </div>
    </div>
  );
}
